/**
 * Отдаёт пользователю готовый файл.
 *
 * Ссылка обязательно попадает в DOM до клика — часть браузеров игнорирует
 * скачивание по элементу вне документа. URL освобождается отложенно: отзыв в том
 * же тике, что и клик, обрывает скачивание в некоторых браузерах.
 */
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = fileName;
  link.style.display = 'none';

  document.body.appendChild(link);

  try {
    link.click();
  } finally {
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(url), 0);
  }
}
